<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <iframe id="sms-module" [src]="vm.blueIdeaUrl" width="100%" height="550"></iframe>
  }
</dff-side>
